import { Button, Icons } from '@cast/design-system';

import { ScalingPolicyHpaFormFields } from '../../_constants/_constants';
import { hpaSettingsConstants } from '../../_constants/hpaSettingsConstants';
import { useHpaSelectedSettingName } from '../../hpaSelectedSettingNameContexts';

export const NextHpaSettingsButton = () => {
  const { settingName, setSettingName, settingsList } =
    useHpaSelectedSettingName<ScalingPolicyHpaFormFields>();

  const nextSettingName =
    settingsList[settingsList.indexOf(settingName) + 1] || settingsList[0];

  const { title } = hpaSettingsConstants[nextSettingName];

  return (
    <Button
      variant="text"
      endIcon={<Icons.ArrowDown />}
      onClick={() => setSettingName(nextSettingName)}
      data-testid="next-setting-button"
    >
      {title}
    </Button>
  );
};
